"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
var _dateFns = require("date-fns");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CustomDatePicker = props => {
  var setupSelectedDate = '';
  var setupCalStartDate = '';
  var setupCalEndDate = '';
  // Setup for selectedDate, calStartDate, calEndDate
  // DatePicker needs date in yyyy-MM-dd format for form submission
  if (props.value != null) {
    // format date for Eastern Timezone so date picked shows properly on frontend
    // split off timezone & parse date in existing format (yyyy-MM-dd) and create a new Date()
    var splitDate = (0, _lodash.split)(props.value, 'T');
    setupSelectedDate = (0, _dateFns.parse)(splitDate[0], 'yyyy-MM-dd', new Date());
  }
  if (props.field.model.min != null) {
    // format date for Eastern Timezone so date picked shows properly on frontend
    // split off timezone & parse date in existing format (yyyy-MM-dd) and create a new Date()
    var _splitDate = (0, _lodash.split)(props.field.model.min, 'T');
    setupCalStartDate = (0, _dateFns.parse)(_splitDate[0], 'yyyy-MM-dd', new Date());
  }
  if (props.field.model.max != null) {
    // format date for Eastern Timezone so date picked shows properly on frontend
    // split off timezone & parse date in existing format (yyyy-MM-dd) and create a new Date()
    var _splitDate2 = (0, _lodash.split)(props.field.model.max, 'T');
    setupCalEndDate = (0, _dateFns.parse)(_splitDate2[0], 'yyyy-MM-dd', new Date());
  }
  var [selectedDate, setSelectedDate] = (0, _react.useState)(props.value !== '' && props.value != null ? setupSelectedDate : null);
  var calStartDate = props.field.model.min !== '' && props.field.model.min != null ? setupCalStartDate : null;
  var calEndDate = props.field.model.max !== '' && props.field.model.max != null ? setupCalEndDate : null;

  // get a handle to the content fields
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name,
    dateLabel = field.model.title,
    required = field.model.required,
    conditionId = field.model.conditionSettings.fieldKey,
    state = _conditionalRendering.store.getState();
  var hasError = false,
    showRequired = '';
  var valid = true;

  // setup for layout
  var labelCss = props.field.model.labelCssClass;
  var shouldHide;
  var feedbackType = '';
  var displayErrors = '';
  // setup for if the field is required
  if (field.model.required) {
    showRequired = '*';
  }

  // setup for error handling
  if (props.errors.length > 0) {
    hasError = true;
    feedbackType = 'invalid';
    displayErrors = props.errors.map((error, index) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "is-invalid"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "invalid-feedback",
        key: index
      }, error.substring(0, 1) === ' ' ? 'field' + error : error));
    });
  }
  var handleOnChange = (date, evt) => {
    var newValue = date;
    var fieldKey = field.model.conditionSettings.fieldKey;
    if (!(0, _lodash.isNull)(date) || !(0, _lodash.isEmpty)(date)) {
      newValue = (0, _dateFns.format)(date, 'yyyy-MM-dd', new Date());
      setSelectedDate(date);
    } else {
      if ((0, _dateFns.isValid)(evt.target.value)) {} else {
        if (!(0, _lodash.isNull)(evt.target.value) || !(0, _lodash.isEmpty)(evt.target.value)) {
          newValue = evt.target.value;
          setSelectedDate(null);
        } else {
          newValue = 'invalid_date';
          var date2 = '';
          setSelectedDate(date2);
        }
      }
    }
    if (state !== undefined) {
      state.fieldValues[fieldKey] = date;
    }
    var valid = true,
      errorMessages = [];
    var startDateValidity = true;
    var endDateValidity = true;
    if ((!(0, _lodash.isNull)(calStartDate) || !(0, _lodash.isEmpty)(calStartDate)) && !(0, _lodash.isNull)(newValue) && !(0, _lodash.isEmpty)(newValue)) {
      if (newValue < (0, _dateFns.format)(calStartDate, 'yyyy-MM-dd', new Date())) {
        startDateValidity = false;
      }
    }
    if ((!(0, _lodash.isNull)(calEndDate) || !(0, _lodash.isEmpty)(calEndDate)) && !(0, _lodash.isNull)(newValue) && !(0, _lodash.isEmpty)(newValue)) {
      if (newValue > (0, _dateFns.format)(calEndDate, 'yyyy-MM-dd', new Date())) {
        endDateValidity = false;
      }
    }
    if (!startDateValidity || !endDateValidity) {
      valid = false;
      newValue = 'invalid_date';
      errorMessages.push(field.model.title !== '' ? field.model.title + ' is not in the proper date range' : 'field is not in the proper date range');
    }
    if (field.model.required && !date) {
      valid = false;
      errorMessages.push(field.model.title !== '' ? field.model.title + ' is required' : 'field is required');
    }
    props.onChange(fieldName, newValue, valid, errorMessages);
  };

  // setup for this field if it is part of a conditional
  if (state !== undefined) {
    var valdate = (0, _dateFns.format)(new Date(selectedDate), 'yyyy-MM-dd');
    var fieldValues = state.fieldValues;
    fieldValues[field.model.conditionSettings.fieldKey] = valdate; //make sure selected default value applied as well

    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(fieldValues, state.conditions[conditionId]);
    var hideArray = state.hiddenFields;
    if (shouldHide) {
      if (hideArray.indexOf(fieldName) === -1) {
        hideArray.push(fieldName);
      }
    } else {
      if (hideArray.indexOf(fieldName) > -1) {
        hideArray = hideArray.filter(e => e !== fieldName);
      }
    }
    state.hiddenFields = hideArray;
  }
  if (shouldHide) {
    return null;
  } else {
    // options are within the form setup - static & dynamic values
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DatePicker, {
      id: fieldId,
      inputType: "text",
      label: dateLabel !== '' ? dateLabel + showRequired : '',
      selected: selectedDate,
      className: labelCss,
      required: required,
      onChange: handleOnChange,
      hasError: hasError,
      errorText: props.errors[0],
      feedbackType: feedbackType !== '' ? feedbackType : undefined,
      minDate: calStartDate,
      maxDate: calEndDate
    })));
  }
};
var _default = exports.default = CustomDatePicker;